import { AxiosResponse } from 'axios'
import { apiNode } from './api'
import {
	DeleteUserAccountDataProps,
	GetCurrentUserObjectData,
	GetMfaResponseData,
	SearchUsersDataResponse,
	SearchUsersParamsProps,
	UpdateCurrentUserObjectDataProps,
	UploadAvatarDataProps,
	GetUserPermissionSetsDataResponse,
} from './types/user.interfaces'

const URL = '2/users/v2'

export const UserService = {
	async getUser() {
		const response: AxiosResponse<GetCurrentUserObjectData> =
			await apiNode.get<GetCurrentUserObjectData>(`${URL}/user/profile`)
		return response.data
	},
	async updateUserProfile({
		data,
	}: {
		data: UpdateCurrentUserObjectDataProps
	}) {
		return await apiNode.patch(`${URL}/user/profile`, data)
	},
	async search({
		params,
	}: {
		params: SearchUsersParamsProps
	}): Promise<SearchUsersDataResponse> {
		const response = await apiNode.get<SearchUsersDataResponse>(
			`${URL}/users/search`,
			{
				params,
			},
		)
		return response?.data
	},
	async getUserPermissionSets(): Promise<GetUserPermissionSetsDataResponse> {
		const response: AxiosResponse<GetUserPermissionSetsDataResponse> =
			await apiNode.get<GetUserPermissionSetsDataResponse>(
				`${URL}/user/permission-sets`,
			)
		return response?.data
	},
	async uploadAvatar({ data }: { data: UploadAvatarDataProps }) {
		const formData = new FormData()
		formData.append('Picture', data.Picture)
		formData.append('Width', String(data.Width))
		formData.append('Height', String(data.Height))
		formData.append('X', String(data.X))
		formData.append('Y', String(data.Y))
		return await apiNode.patch(`${URL}/user/profile/avatar`, formData)
	},
	async deleteAvatar() {
		const response = await apiNode.delete(`${URL}/user/profile/avatar`)
		return response
	},
	async changePasswordRequest() {
		return await apiNode.post('2/users/v2/user/password-change', {})
	},
	async getMfa() {
		const response: AxiosResponse<GetMfaResponseData> =
			await apiNode.get<GetMfaResponseData>(`${URL}/user/mfa`)
		return response.data
	},
	async toggleMfaRequest({ value }: { value: boolean }) {
		return await apiNode.post('2/users/v2/user/mfa', { value })
	},
	async confirmPassword(password: string, email: string) {
		return await apiNode.post(`${URL}/user/token`, {
			username: email,
			password: password,
		})
	},
	async verifyOtp(mfa_token: string, otp: string) {
		return await apiNode.post(`${URL}/user/mfa/verify`, {
			mfa_token,
			otp,
		})
	},

	async toggleMfa({
		username,
		password,
		value,
		mfa_token,
		otp,
	}: {
		username?: string
		password?: string
		value: boolean
		mfa_token?: string
		otp?: string
	}) {
		return await apiNode.post('2/users/v2/user/mfa/toggle', {
			username,
			password,
			value,
			mfa_token,
			otp,
		})
	},

	async deleteAccount({ reason, details }: DeleteUserAccountDataProps) {
		const params: Record<string, string> = {}
		if (!!reason) params.reason = reason
		if (!!details) params.details = details
		const response = await apiNode.delete(`${URL}/user`, {
			params,
		})
		return response
	},
}
